var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1070 -140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1110,
    cy: 180,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2552.087 178.747)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1418,6.2C-1418,6.2-1418,6.2-1418,6.2c0-0.1,0-0.1,0-0.2c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1l0,0 c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0l0,0l-18.3-6.6l-3.1-27.4v0c0-0.1,0-0.1-0.1-0.2l0,0c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1 c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0,0l-16.2,3.6h0c-0.1,0-0.1,0-0.2,0.1 c0,0,0,0,0,0c0,0,0,0-0.1,0.1L-1472-7.6c-0.2,0.2-0.2,0.5,0,0.7l14.1,15.7l1.2,14.1c0,0.2,0.1,0.3,0.3,0.4l19.8,7.9c0,0,0,0,0,0 c0.1,0,0.1,0,0.2,0l0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0l17.8-11.9c0.1-0.1,0.2-0.2,0.2-0.4L-1418,6.2 C-1418,6.2-1418,6.2-1418,6.2z M-1436.8,29.5l-18.7-19.7l18.7,7V29.5z M-1436.4,16l-19.7-7.4l18.9-8.5l17.4,6.3L-1436.4,16z  M-1456.2-12.9l2.5-2.3l15.7,14.5l-18.4,8.3L-1456.2-12.9z M-1437.8-1.8l-15.2-14.1l12.3-11.4L-1437.8-1.8z M-1456.2-14.2 l0.1-10.1l14.1-3.1L-1456.2-14.2z M-1457.4,7.7l-13.5-15l13.9-16.1L-1457.4,7.7z M-1455.7,22.5l-1-12.5l18.5,19.5L-1455.7,22.5z  M-1435.9,29.8v-13l16.8-9.7v11.6L-1435.9,29.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigest);
export default __webpack_public_path__ + "static/media/digest.e5d11970ab3e8967f1adaa0a712a78e6.svg";
export { ForwardRef as ReactComponent };